document.addEventListener("DOMContentLoaded", function() {
  var links = document.querySelectorAll(".metafield-rich_text_field a");
  links.forEach(function(link) {
    link.setAttribute("target", "_blank");
  });
});

// Connect quantity fields on Product page
document.addEventListener('DOMContentLoaded', function() {
    // Select both input elements
    var inputs = document.querySelectorAll('.quantity-selector__input');

    // Store the previous values to track changes
    var previousValues = [inputs[0].value, inputs[1].value];

    // Function to sync input values
    function syncInputs() {
        var value1 = inputs[0].value;
        var value2 = inputs[1].value;

        // Check if input 1 was updated, then sync input 2
        if (value1 !== previousValues[0]) {
            inputs[1].value = value1;
            previousValues[0] = value1;
            previousValues[1] = value1;
        }

        // Check if input 2 was updated, then sync input 1
        if (value2 !== previousValues[1]) {
            inputs[0].value = value2;
            previousValues[0] = value2;
            previousValues[1] = value2;
        }
    }

    // Use setInterval to check the input values every 300 milliseconds
    setInterval(syncInputs, 500);
});
